import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import RitSelect from '../RitSelect';


export default class SelectSavedSizes extends React.Component {
  constructor(props) {
    super(props);
  }

  onChange = (value) => {
    this.props.onSizeSelect(value)
  }

  render() {
    const { shirtProfiles, selectOnly, value, defaultText } = this.props;

    const values = shirtProfiles.map((p) => ({
      name: p.displayName,
      value: p
    }));

    const select = (
      <RitSelect
        optionsList={values}
        value={value}
        onChange={this.onChange}
        defaultText={defaultText || 'Профиль размеров'}
        withSearch={true}
      />
    );

    if (selectOnly) {
      return (
        <Fragment>
          {select}
        </Fragment>
      )
    }

    return (
      <div className="b-rit-smart-mark__wrapper" >
        <p className='b-rit-smart-mark__header'>
          Сохраненный профиль размеров
        </p>
        <p className='b-rit-smart-mark__body'>
          Выберите один из сохраненных размеров или создайте новый,
          используя один из способов ниже
        </p>
        <div className='b-rit-smart-mark__sizes-wrap'>
          {select}
        </div>
      </div>
    )
  }
}

SelectSavedSizes.propTypes = {
  onSizeSelect: PropTypes.func.isRequired,
  shirtProfiles: PropTypes.array.isRequired,
  selectOnly: PropTypes.bool,
  value: PropTypes.any,
  defaultText: PropTypes.string
}